import React from 'react'
import { Box, Flex, Group, Button, Text, Tooltip, CopyButton, ThemeIcon, Paper } from '@mantine/core'
import { IconCheck, IconCopy, IconWindowMaximize } from '@tabler/icons-react'

const ShareLinkProduct = ({ dataProduct, onCloseModal }) => {
  console.log('aaa', dataProduct)
  const appUrl = 'https://app.asiacommerce.net'

  const openNewTab = (url) => {
    window.open(`${url}`, '_blank')
  }

  if (dataProduct !== null) {
    return (
      <Box>
        <Box mb='lg'>
          <Paper shadow="xs" withBorder p="lg">
            <Text fz={14} fw='600' mb={2}>Product URL</Text>
              <Text fz={12} fw='500' c='gray.6' mb={1}>URL</Text>
              <Flex gap={4} align='center'>
                <Text fz={12} c='blue.9' lineClamp={1}>{`${appUrl}/catalog/${dataProduct.productId}`}</Text>
                <CopyButton value={`${appUrl}/catalog/${dataProduct.productId}`} timeout={2000}>
                  {({ copied, copy }) => (
                    <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                      <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                        {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                      </ThemeIcon>
                    </Tooltip>
                  )}
                </CopyButton>
                <Tooltip label='Open Link' withArrow position="top">
                  <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${appUrl}/catalog/${dataProduct.productId}`)}>
                    <IconWindowMaximize size={12} />
                  </ThemeIcon>
                </Tooltip>
              </Flex>
              <Flex gap={4} align='center'>
                <Text fz={12} c='blue.9' lineClamp={1}>{`${appUrl}/catalog/${dataProduct.slug}`}</Text>
                <CopyButton value={`${appUrl}/catalog/${dataProduct.slug}`} timeout={2000}>
                  {({ copied, copy }) => (
                    <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                      <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                        {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                      </ThemeIcon>
                    </Tooltip>
                  )}
                </CopyButton>
                <Tooltip label='Open Link' withArrow position="top">
                  <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${appUrl}/catalog/${dataProduct.slug}`)}>
                    <IconWindowMaximize size={12} />
                  </ThemeIcon>
                </Tooltip>
              </Flex>
          </Paper>
        </Box>
        <Box mb='lg'>
          <Paper shadow="xs" withBorder p="lg">
            <Text fz={14} fw='600' mb={2}>Public Product URL</Text>
            <Text fz={12} fw='500' c='gray.6' mb={1}>URL</Text>
            <Flex gap={4} align='center'>
              <Text fz={12} c='blue.9' lineClamp={1}>{`${appUrl}/product/${dataProduct.productId}`}</Text>
              <CopyButton value={`${appUrl}/product/${dataProduct.productId}`} timeout={2000}>
                {({ copied, copy }) => (
                  <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                    <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                      {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                    </ThemeIcon>
                  </Tooltip>
                )}
              </CopyButton>
              <Tooltip label='Open Link' withArrow position="top">
                <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${appUrl}/product/${dataProduct.productId}`)}>
                  <IconWindowMaximize size={12} />
                </ThemeIcon>
              </Tooltip>
            </Flex>
            <Flex gap={4} align='center'>
              <Text fz={12} c='blue.9' lineClamp={1}>{`${appUrl}/product/${dataProduct.slug}`}</Text>
              <CopyButton value={`${appUrl}/product/${dataProduct.slug}`} timeout={2000}>
                {({ copied, copy }) => (
                  <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                    <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                      {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                    </ThemeIcon>
                  </Tooltip>
                )}
              </CopyButton>
              <Tooltip label='Open Link' withArrow position="top">
                <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${appUrl}/product/${dataProduct.slug}`)}>
                  <IconWindowMaximize size={12} />
                </ThemeIcon>
              </Tooltip>
            </Flex>
          </Paper>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="filled" onClick={onCloseModal}>Close</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }
}

export default ShareLinkProduct